import BaseScreen from "../BaseScreen";
import NavBar from "../../components/NavBar";
import { MainNavProps } from "../navigation/main/MainParamList";
import React, { useState, useEffect } from "react";
import { blackOperator, delFriend } from "../../net/service";
import { CommonSetting } from "../../components/setting/CommonSetting";
import { Pressable, Text, View } from "react-native";
import { color_main, ColorRed, white } from "../../assets/style/colors";
import * as ImSdk from "../../../imsdk/api";
import time from "../../../imsdk/time";
import { showDialog } from "../../components/CommonDialog";
import {
  Str_AddFriendBlackTip,
  Str_Cancel,
  Str_ContactDeleted,
  Str_DelFail,
  Str_DelFriend,
  Str_DelFriendTip,
  Str_JoinBlacklist,
  Str_Report,
  Str_SettingInformation,
} from "../../language/string_res";
import { buildSignalTopicId } from "../../utils/utils";
import { useStore } from "../../store/UserStore";
import { hideLoading, showLoading } from "../../components/Loading";
import { showToast } from "../../components/Toast";
import { ScreenCloseModal, ScreenModal } from "../../components/ScreenModal";
import globalEventBus from "../../utils/EventBus";

export const ContactSetting = ({
  navigation,
  route,
}: MainNavProps<"ContactSetting">) => {
  // 直接从 route.params 获取最新的参数，不依赖 useState 的初始化
  const { current } = route.params || {};
  const uid = current?.uid;
  const [isBlack, setIsBlack] = useState(false);
  const im = ImSdk.getInstance();
  const { dispatch } = useStore();

  // 当组件挂载或路由参数变化时，重新获取黑名单状态
  useEffect(() => {
    if (route.params && route.params.current && route.params.current.uid) {
      const { current: newCurrent } = route.params;
      
      // 直接从服务器获取最新的黑名单状态，不依赖传递的参数
      im.GetFriendBlack().then((res) => {
        if (res.blacks) {
          const isInBlackList = res.blacks.some((item) => item.uid === newCurrent.uid);
          setIsBlack(isInBlackList);
        } else {
          setIsBlack(false);
        }
      }).catch((error) => {
        setIsBlack(false);
      });
    }
  }, [route.params]);

  const handleDelete = () => {
    showDialog({
      message: Str_DelFriendTip,
      cancelText: Str_Cancel,
      onConfirm: handleDelUser,
    });
  };
  const handleDelUser = () => {
    showLoading();

    delFriend(uid)
      .then((res) => {
        if (!res || res.code !== 0) {
          hideLoading();
          showToast(res.msg || Str_DelFail);
          return;
        }

        onDelFriendRequestSuccess();
      })
      .catch((err) => {
        hideLoading();
        showToast(Str_DelFail);
      });
  };

  const onDelFriendRequestSuccess = () => {
    const tid = buildSignalTopicId(uid, im.CurrentUid());
    im.GetTopicDetail(tid, true).then((res) => {
      if (!res.topic) {
        hideLoading();
        navigation.navigate("MainTab");
        return;
      }

      const lsMid = res.topic.topic.lsMid;
      const promise1 = im.SetTopicProps({
        tid: tid,
        hidemid: lsMid,
      });
      const promise2 = im.CleanMsg(tid, lsMid);
      const promise3 = im.DelLabelByUid(uid);
      Promise.all([promise1, promise2, promise3])
        .then((resp) => {
          ImSdk.getInstance().SetCache(`${tid}_latest_msgs`, []);
          dispatch({ type: "DELETE_USER", payload: uid });
          im.DelTopic(tid).then();
          navigation.navigate("MainTab");
        })
        .finally(() => {
          hideLoading();
        });
    });
  };

  const handBlack = (newValue: boolean) => {
    // 注意：根据API文档，op=0是加入黑名单，op=1是拉出黑名单
    const op = newValue ? 0 : 1;
    blackOperator(uid, op).then((res) => {
      if (res.code === 0) {
        setIsBlack(newValue);
        const im = ImSdk.getInstance();
        const black = newValue ? "1" : "";
        im.SetFriendBlack(uid, black).then();
        im.emit("user_black", {
          user_black: {
            uid: uid,
            black: black,
            time: time.toUnixMillSecond(time.now()),
          },
        });
        // 触发黑名单页面更新，添加延迟以确保服务器状态已更新
        setTimeout(() => {
          globalEventBus.emit("BlackList_Update");
        }, 500);
      } else {
        setIsBlack(!newValue);
      }
    });
  };
  const handBlackOperator = (newValue: boolean) => {
    if (newValue) {
      showDialog({
        message: Str_AddFriendBlackTip,
        outDismiss: false,
        cancelText: Str_Cancel,
        onCancel: () => {
          setIsBlack(false);
        },
        onConfirm: () => {
          handBlack(newValue);
        },
      });
    } else {
      handBlack(newValue);
    }
  };
  return (
    <ScreenCloseModal title={Str_SettingInformation}>
      {(current.status === "deleted") && (
        <View style={{ padding: 20, alignItems: "center", flex: 1, justifyContent: "center" }}>
          <Text style={{ fontSize: 17, color: "#333", fontWeight: "bold", marginBottom: 50 }}>
            {Str_ContactDeleted}
          </Text>
        </View>
      )}
      {!(current.status === "deleted") && (<CommonSetting
        style={{
          marginTop: 24,
          marginHorizontal: 24,
        }}
        itemOption={[
          {
            text: Str_JoinBlacklist,
            rightType: "Switch",
            switchIsEnabled: isBlack,
            switchChange: (newValue) => handBlackOperator(newValue),
          },
          {
            text: Str_Report,
            onClick: () => {
              navigation.navigate("Report", { uid: uid });
            },
          },
        ]}
      />)}

      <View style={{ marginTop: 40, alignItems: "center", paddingBottom: 20 }}>
        <Pressable
          onPress={handleDelete}
          style={{
            backgroundColor: ColorRed,
            borderRadius: 12,
            paddingVertical: 16,
            paddingHorizontal: 60,
            minWidth: 200,
            maxWidth: 300,
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 40,
          }}
        >
          <Text
            style={{
              color: white,
              fontSize: 16,
              fontWeight: "600",
            }}
          >
            {Str_DelFriend}
          </Text>
        </Pressable>
      </View>
    </ScreenCloseModal>
  );
};
